const enum IsaacTagDialogType {
  ADD = "add",
  DELETE = "delete",
}

export default IsaacTagDialogType;
